import { iTermnsAndConditions } from "../presentation/interfaces/terms-and-conditions.interface";
import { createApiError, normalizeToApiError } from "./error.service";
import { interceptorFetch } from "./interceptor.service";

export async function findTermsAndConditionsByEmployee(employeeId: number, token: string, updateToken: (newToken: string) => void): Promise<iTermnsAndConditions | null> {
    try {
        const response = await interceptorFetch(`terms-and-conditions/employee/${employeeId}`, token, updateToken, { method: "GET" });

        if (!response.ok) {
            const errorData = await response.json().catch(() => ({ message: 'Error fetching terms and conditions' }));
            throw createApiError(errorData, response.status);
        }
        const data = await response.json();
        return data;

    } catch (error) {
        throw normalizeToApiError(error);
    }
}

